import { Box } from '@mui/material';

const SkeletonList = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
    {[...Array(6)].map((_, i) => (
      <Box
        key={i}
        sx={{
          width: '292px',
          minHeight: '92px',
          borderRadius: '8px',
          border: '1px solid #D4DADF',
          bgcolor: '#FFFFFF',
          p: '12px 12px 20px 12px',
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
        }}
      >
        {/* Line 1 */}
        <Box
          sx={{
            width: '268px',
            height: '20px',
            borderRadius: '6px',
            background: 'linear-gradient(270deg, #F9FAFB 103.5%, #E5E7EB 179.69%)',
            '@keyframes shimmer': {
              '0%': { backgroundPosition: '200% center' },
              '100%': { backgroundPosition: '-200% center' },
            },
            animation: 'shimmer 1.8s ease-in-out infinite',
            backgroundSize: '200% 100%',
          }}
        />
        {/* Line 2 */}
        <Box
          sx={{
            width: '200px',
            height: '20px',
            borderRadius: '6px',
            background: 'linear-gradient(270deg, #F9FAFB 103.5%, #E5E7EB 179.69%)',
            animation: 'shimmer 1.8s ease-in-out infinite',
            backgroundSize: '200% 100%',
          }}
        />
        {/* Line 3 — short */}
        <Box
          sx={{
            width: '100px',
            height: '20px',
            borderRadius: '6px',
            background: 'linear-gradient(270deg, #F9FAFB 103.5%, #E5E7EB 179.69%)',
            animation: 'shimmer 1.8s ease-in-out infinite',
            backgroundSize: '200% 100%',
          }}
        />
      </Box>
    ))}
  </Box>
);

export default SkeletonList;
